import { useAppSelector } from 'shared/hooks/redux/hooks';
import { selectSelectedDevice } from 'entities/device/lib';
import { useContext, useMemo } from 'react';
import { useDesignPackage } from 'console/shared/hooks/helpers';
import { web_element_icons, } from 'console/shared/components/fields/icon/icons';
import { heating_circuits_custom_icons } from 'console/shared/components/fields/icon/icons/heating-circuits';
import { DeviceConfig } from 'console/shared/contexts/device/config/types';
export const useWebElementIcon = (id) => {
    const { device_ui_settings } = useContext(DeviceConfig);
    const web_elements_icons_config = useMemo(() => device_ui_settings.icons?.web_elements, [device_ui_settings]);
    const device_type = useAppSelector((state) => selectSelectedDevice(state)?.device_type);
    const web_element_icon_id = useMemo(() => (web_elements_icons_config ? web_elements_icons_config[id] : null), [web_elements_icons_config, id]);
    const is_socket = useMemo(() => device_type?.code === 'SOCKETS_03', [device_type?.code]);
    const allow_design_package = useDesignPackage();
    const icon = useMemo(() => {
        if (typeof web_element_icon_id === 'string') {
            if (allow_design_package) {
                return web_element_icon_id;
            }
            else {
                return [heating_circuits_custom_icons[0]];
            }
        }
        else {
            const finded_icon = web_element_icons.find((settings_icon) => settings_icon.id === web_element_icon_id);
            if (finded_icon == null) {
                if (is_socket) {
                    const socket_icon = web_element_icons.find(({ id }) => id == 300);
                    if (socket_icon) {
                        return socket_icon;
                    }
                }
                return null;
            }
            if (finded_icon.paid && !allow_design_package) {
                return null;
            }
            return finded_icon;
        }
    }, [web_element_icon_id, is_socket, allow_design_package]);
    return icon;
};
